import NAME from "./constants";

export const RESET_ALL = NAME + "/RESET_ALL";

export const GET_ALL_TRAINING = NAME + "/GET_ALL_TRAINING";
export const GET_ALL_TRAINING_REJECTED = NAME + "/GET_ALL_TRAINING_REJECTED";
export const GET_ALL_TRAINING_FULFILLED = NAME + "/GET_ALL_TRAINING_FULFILLED";

// TRAINING
export const GET_SPECIFIC_TRAINING = NAME + "/GET_SPECIFIC_TRAINING";
export const GET_SPECIFIC_TRAINING_REJECTED = NAME + "/GET_SPECIFIC_TRAINING_REJECTED";
export const GET_SPECIFIC_TRAINING_FULFILLED = NAME + "/GET_SPECIFIC_TRAINING_FULFILLED";

export const GET_COURSE_TREE = NAME + "/GET_COURSE_TREE";
export const GET_COURSE_TREE_REJECTED = NAME + "/GET_COURSE_TREE_REJECTED";
export const GET_COURSE_TREE_FULFILLED = NAME + "/GET_COURSE_TREE_FULFILLED";

export const CREATE_TRAINING = NAME + "/CREATE_TRAINING";
export const CREATE_TRAINING_REJECTED = NAME + "/CREATE_TRAINING_REJECTED";
export const CREATE_TRAINING_FULFILLED = NAME + "/CREATE_TRAINING_FULFILLED";

export const UPDATE_TRAINING = NAME + "/UPDATE_TRAINING";
export const UPDATE_TRAINING_REJECTED = NAME + "/UPDATE_TRAINING_REJECTED";
export const UPDATE_TRAINING_FULFILLED = NAME + "/UPDATE_TRAINING_FULFILLED";

export const DELETE_TRAINING = NAME + "/DELETE_TRAINING";
export const DELETE_TRAINING_REJECTED = NAME + "/DELETE_TRAINING_REJECTED";
export const DELETE_TRAINING_FULFILLED = NAME + "/DELETE_TRAINING_FULFILLED";

export const DUPLICATE_TRAINING = NAME + "/DUPLICATE_TRAINING";
export const DUPLICATE_TRAINING_REJECTED = NAME + "/DUPLICATE_TRAINING_REJECTED";
export const DUPLICATE_TRAINING_FULFILLED = NAME + "/DUPLICATE_TRAINING_FULFILLED";

export const RESET_SPECIFIC_TRAINING = NAME + "/RESET_SPECIFIC_TRAINING";

// MODULES
export const GET_MODULES = NAME + "/GET_MODULES";
export const GET_MODULES_REJECTED = NAME + "/GET_MODULES_REJECTED";
export const GET_MODULES_FULFILLED = NAME + "/GET_MODULES_FULFILLED";

export const CREATE_MODULE = NAME + "/CREATE_MODULE";
export const CREATE_MODULE_REJECTED = NAME + "/CREATE_MODULE_REJECTED";
export const CREATE_MODULE_FULFILLED = NAME + "/CREATE_MODULE_FULFILLED";

export const UPDATE_MODULE = NAME + "/UPDATE_MODULE";
export const UPDATE_MODULE_REJECTED = NAME + "/UPDATE_MODULE_REJECTED";
export const UPDATE_MODULE_FULFILLED = NAME + "/UPDATE_MODULE_FULFILLED";

export const DELETE_MODULE = NAME + "/DELETE_MODULE";
export const DELETE_MODULE_REJECTED = NAME + "/DELETE_MODULE_REJECTED";
export const DELETE_MODULE_FULFILLED = NAME + "/DELETE_MODULE_FULFILLED";

// ASSIGN
export const GET_TRAINING_ASSIGNMENT = NAME + "/GET_TRAINING_ASSIGNMENT";
export const GET_TRAINING_ASSIGNMENT_REJECTED = NAME + "/GET_TRAINING_ASSIGNMENT_REJECTED";
export const GET_TRAINING_ASSIGNMENT_FULFILLED = NAME + "/GET_TRAINING_ASSIGNMENT_FULFILLED";

export const CREATE_TRAINING_ASSIGNMENT = NAME + "/CREATE_TRAINING_ASSIGNMENT";
export const CREATE_TRAINING_ASSIGNMENT_REJECTED = NAME + "/CREATE_TRAINING_ASSIGNMENT_REJECTED";
export const CREATE_TRAINING_ASSIGNMENT_FULFILLED = NAME + "/CREATE_TRAINING_ASSIGNMENT_FULFILLED";

export const DELETE_TRAINING_ASSIGNMENT = NAME + "/DELETE_TRAINING_ASSIGNMENT";
export const DELETE_TRAINING_ASSIGNMENT_REJECTED = NAME + "/DELETE_TRAINING_ASSIGNMENT_REJECTED";
export const DELETE_TRAINING_ASSIGNMENT_FULFILLED = NAME + "/DELETE_TRAINING_ASSIGNMENT_FULFILLED";

export const RESET_TRAINING_ASSIGNMENT = NAME + "/RESET_TRAINING_ASSIGNMENT";

// ACTIVITIES
export const GET_ACTIVITIES = NAME + "/GET_ACTIVITIES";
export const GET_ACTIVITIES_REJECTED = NAME + "/GET_ACTIVITIES_REJECTED";
export const GET_ACTIVITIES_FULFILLED = NAME + "/GET_ACTIVITIES_FULFILLED";

export const GET_ACTIVITY = NAME + "/GET_ACTIVITY";
export const GET_ACTIVITY_REJECTED = NAME + "/GET_ACTIVITY_REJECTED";
export const GET_ACTIVITY_FULFILLED = NAME + "/GET_ACTIVITY_FULFILLED";

export const CREATE_ACTIVITY = NAME + "/CREATE_ACTIVITY";
export const CREATE_ACTIVITY_REJECTED = NAME + "/CREATE_ACTIVITY_REJECTED";
export const CREATE_ACTIVITY_FULFILLED = NAME + "/CREATE_ACTIVITY_FULFILLED";

export const UPDATE_ACTIVITY = NAME + "/UPDATE_ACTIVITY";
export const UPDATE_ACTIVITY_REJECTED = NAME + "/UPDATE_ACTIVITY_REJECTED";
export const UPDATE_ACTIVITY_FULFILLED = NAME + "/UPDATE_ACTIVITY_FULFILLED";

export const DELETE_ACTIVITY = NAME + "/DELETE_ACTIVITY";
export const DELETE_ACTIVITY_REJECTED = NAME + "/DELETE_ACTIVITY_REJECTED";
export const DELETE_ACTIVITY_FULFILLED = NAME + "/DELETE_ACTIVITY_FULFILLED";

export const RESET_MODULES_AND_ACTIVITIES = NAME + "/RESET_MODULES_AND_ACTIVITIES";
export const RESET_ACTIVITY = NAME + "/RESET_ACTIVITY";